import React, { useCallback, useState } from 'react';
import { Popover, Button, Icon, SelectProps } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import EventFilterContent from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent';
import { IEventFilterValue, IEventListItem } from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent/type';
import { IEventFilterProps } from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/type';

export const EventFilter = (props: IEventFilterProps) => {
  const { getLocalText } = useLocal('filter');
  const {
    value,
    triggerTitle,
    hoursSinceRegisterOptions,
    data,
    config,
    onConfirm,
    onCancel,
  } = props;

  const [visible, setVisible] = useState(false);
  const [tempValue, setTempValue] = useState<IEventFilterValue>(value);

  const handleVisibleChange = useCallback((nextVisible: boolean) => {
    setVisible(nextVisible);
    if (nextVisible) {
      setTempValue(value);
    }
  }, [value]);

  const handleConfirm = useCallback((confirmed?: IEventFilterValue) => {
    const finalValue = confirmed ?? tempValue;
    setVisible(false);
    onConfirm(finalValue);
  }, [tempValue, onConfirm]);

  const handleCancel = useCallback(() => {
    setTempValue(value);
    setVisible(false);
    onCancel();
  }, [value, onCancel]);

  return (
    <Popover
      visible={visible}
      onVisibleChange={handleVisibleChange}
      trigger="click"
      placement="bottom-start"
      overlayClassName="dbd-event-exploration-filter__overlay"
      overlay={
        <EventFilterContent
          visible={visible}
          value={tempValue}
          onChange={setTempValue}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          hoursSinceRegisterOptions={hoursSinceRegisterOptions}
          data={data}
          config={config ?? {}}
        />
      }
    >
      <Button type="weak" className="dbd-event-filter-trigger">
        <span className={`dbd-event-filter-trigger__text${triggerTitle === getLocalText('please_select') ? ' dbd-event-filter-trigger__text--placeholder' : ''}`}>{triggerTitle}</span>
        <Icon type="arrowdown" />
      </Button>
    </Popover>
  );
};
